import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  NumberField,
} from 'react-admin';

const WorldList = props => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="visibility" />
      <TextField source="name" />
      <NumberField source="leaderboardsCount" />
      <EditButton />
    </Datagrid>
  </List>
);

export default WorldList;
